import { Links, ReferralReward, Stats } from "@/api/types";
import axios from "axios";

export const getStats = () => axios.get<Stats>('/stats');
export const getLinks = () => axios.get<Links>('/stats/links');
export const getReferralRewards = (user_id?: number) =>
    axios.get<ReferralReward>(
        '/stats/referrals',
        user_id != null ? { params: { user_id } } : undefined
    );
